var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgSend = function SvgSvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.47 18.5a1.7 1.7 0 0 1-1.525-.941L10.5 13l-4.558-.445a1.706 1.706 0 0 1 .096-3.092L16.124 5.14a1.7 1.7 0 0 1 1.352-.001 1.71 1.71 0 0 1 .89 2.241l-4.332 10.087A1.7 1.7 0 0 1 12.47 18.5m-5.843-7.657a.2.2 0 0 0-.11.112.2.2 0 0 0 0 .156.2.2 0 0 0 .097.103l4.984.149a.75.75 0 0 1 .334.335l.354 5.188a.2.2 0 0 0 .117.102.197.197 0 0 0 .156-.011.2.2 0 0 0 .098-.102l4.331-10.088a.206.206 0 0 0-.107-.271.204.204 0 0 0-.163.001l-.021.009z"
  })));
};
export default SvgSvgSend;